import { BASE_CORE_URL, BASE_URL, UAPI_URL_CCTV, UAPI_URL_CONFIG } from "../../config";
import { ErrorToast } from "../../CustomHooks/ErrorToast";
import { SuccessToast } from "../../CustomHooks/SuccessToast";
import { WarningToast } from "../../CustomHooks/WarningToast";
import { cameraActions } from "../../redux/features/camera/camera";
import { recordingActions } from "../../redux/features/recording/recording";
import { fetchSavedFiltersList } from "../filterService";

export const saveFilter = (pName, pType, filterText) => async (dispatch) => {
    try {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };
        let loggedInUser = JSON.parse(localStorage.getItem('user'));
        let userUniqueId = loggedInUser?.Id;
        // let url = BASE_CORE_URL + "Device/SaveFilter" + `?pName=${pName}&pType=${pType}&userUniqueId=${userUniqueId}&filterText=${filterText}`;
        let url = UAPI_URL_CONFIG + "filter/SaveFilter" + `?pName=${pName}&pType=${pType}&userUniqueId=${userUniqueId}&filterText=${filterText}`;
        const response = await fetch(url, requestOptions).then(res => res.json());

        if (response?.Status === "success") {
            SuccessToast(response?.Message)

            dispatch(fetchSavedFiltersList(pType))
            // const DDLData = response?.Data?.map(item => {
            //     const { ClientId, ClientName } = item;
            //     return { label: ClientName, value: parseInt(ClientId) }
            // })
            // dispatch(cameraActions.setSavedFiltersList(DDLData));
        } else if (response?.Status === "failed") {
            ErrorToast(response?.Message)
        }
    }
    catch (ex) {
        console.log(ex);
    }
}

// export const fetchDevicesList = (clientIds, siteIds, interfaceSubTypeIds, interfaceIds, devicesIds, isAppliedBySavedFilter) => async (dispatch) => {
//     try {
//         let loggedInUser = JSON.parse(localStorage.getItem('user'))
//         let uniqueId = loggedInUser.UserUniqueID
//         let uniqueIdd = loggedInUser.Id
//         console.log("uniqueId", uniqueId, uniqueIdd);
        

//         const requestOptions = {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json",
//                 "authcode": localStorage.getItem('authCode'),
//                 "Authorization": "Bearer " + localStorage.getItem('authToken')
//             },
//         };

//         // let url = BASE_CORE_URL + "Cameras/GetDevicesList" + `?uniqueId=${uniqueId}&clientIds=${clientIds}&siteIds=${siteIds}&interfaceSubTypeIds=${interfaceSubTypeIds}&interfaceIds=${interfaceIds}&devicesIds=${devicesIds}`;
//         let url = UAPI_URL_CCTV + "cctv/getSelectAllDevice" + `?uniqueId=${uniqueId}&clientIds=${clientIds}&siteIds=${siteIds}&interfaceSubTypeIds=${interfaceSubTypeIds}&interfaceIds=${interfaceIds}&devicesIds=${devicesIds}`;
//         const response = await fetch(url, requestOptions).then(res => res.json());

//         if (response?.Status === "success" && response?.Data?.length > 0) {
//             SuccessToast(response?.Message)
//             if (isAppliedBySavedFilter) {
//                 dispatch(cameraActions.setDevicesList(response?.Data));
//             } else {
//                 const devicesList = response?.Data?.map(item => {
//                     return {
//                         ...item,
//                         isChecked: true
//                     }
//                 })
//                 dispatch(cameraActions.setDevicesList(devicesList));
//             }
//         }
//     }
//     catch (ex) {
//         console.log(ex);
//     }
// }

export const fetchDevicesList = (clientIds, siteIds, interfaceSubTypeIds, interfaceIds, devicesIds, isAppliedBySavedFilter, deviceType, isQC = false, qcToast = false) => async (dispatch) => {
    try {
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        // let uniqueId = loggedInUser.UserUniqueID
        let uniqueId = loggedInUser.Id        

        // Use POST request with body to avoid 414 URI Too Large errors
        const requestBody = {
            uniqueId: uniqueId,
            clientIds: clientIds ?? "",
            siteIds: siteIds ?? "",
            interfaceSubTypeIds: interfaceSubTypeIds ?? "",
            interfaceIds: interfaceIds ?? "",
            devicesIds: devicesIds ?? "",
            deviceType: deviceType ?? "",
            isQC: isQC
        };

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
            body: JSON.stringify(requestBody)
        };

        let url = UAPI_URL_CCTV + "getSelectAllDevice";
        let response = await fetch(url, requestOptions).then(res => res.json());
        
        // Fallback to GET if POST fails
        if (!response?.Status && response?.status === 405) {
            console.log("POST failed, trying GET fallback");
            const getOptions = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "authcode": localStorage.getItem('authCode'),
                    "Authorization": "Bearer " + localStorage.getItem('authToken')
                },
            };
            const getUrl = UAPI_URL_CCTV + "getSelectAllDevice" + `?uniqueId=${uniqueId}&clientIds=${clientIds ?? ""}&siteIds=${siteIds ?? ""}&interfaceSubTypeIds=${interfaceSubTypeIds ?? ""}&interfaceIds=${interfaceIds ?? ""}&devicesIds=${devicesIds ?? ""}&deviceType=${deviceType ?? ""}&isQC=${isQC}`;
            response = await fetch(getUrl, getOptions).then(res => res.json());
        }
        
        if (response?.Status === "success" && response?.Data?.length > 0) {
            if(!qcToast){
                SuccessToast(response?.Message)
            }
            if (isAppliedBySavedFilter) {
                let temp = response?.Data.map((item) => {
                    const { DeviceId, SiteId, SiteName, TimeZoneID, Name, Abbreviation, OffsetMinutes } = item
                    return {
                        ...item,
                        DeviceId: DeviceId,
                        SiteId: SiteId,
                        SiteName: SiteName,
                        Abbreviation: Abbreviation,
                        OffsetMinutes: OffsetMinutes,
                        CameraName: Name,
                        TimezoneId: TimeZoneID,
                    }
                })
                dispatch(cameraActions.setDevicesList(temp));
            } else {
                const devicesList = response?.Data?.map(item => {
                    const { DeviceId, SiteId, SiteName, TimeZoneID, Name, Abbreviation, OffsetMinutes } = item;
                    return {
                        ...item,
                        DeviceId: DeviceId,
                        SiteId: SiteId,
                        SiteName: SiteName,
                        Abbreviation: Abbreviation,
                        OffsetMinutes: OffsetMinutes,
                        CameraName: Name,
                        TimezoneId: TimeZoneID,
                        isChecked: true
                    }
                })
                dispatch(cameraActions.setDevicesList(devicesList));                
            }
        }else{
            dispatch(cameraActions.setDevicesList([]))
            if(!qcToast){
                WarningToast("No cameras found.")
            }
        }
    }
    catch (ex) {
        console.log(ex);
    }
}

export const fetchRecordingDevicesList = (clientIds, siteIds, interfaceSubTypeIds, interfaceIds, devicesIds, isAppliedBySavedFilter, deviceType) => async (dispatch) => {
    try {
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        // let uniqueId = loggedInUser.UserUniqueID
        let uniqueId = loggedInUser?.Id        

        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };

        // let url = BASE_CORE_URL + "Cameras/GetDevicesList" + `?uniqueId=${uniqueId}&clientIds=${clientIds}&siteIds=${siteIds}&interfaceSubTypeIds=${interfaceSubTypeIds}&interfaceIds=${interfaceIds}&devicesIds=${devicesIds}`;
        let url = UAPI_URL_CCTV + "getAllRecodingDevices" + `?uniqueId=${uniqueId}&clientIds=${clientIds}&siteIds=${siteIds}&interfaceSubTypeIds=${interfaceSubTypeIds}&interfaceIds=${interfaceIds}&devicesIds=${devicesIds}&deviceType=${deviceType}`;
        const response = await fetch(url, requestOptions).then(res => res.json());
        
        if (response?.Status === "success" && response?.Data?.length > 0) {
            SuccessToast(response?.Message)
            if (isAppliedBySavedFilter) {
                let temp = response?.Data.map((item) => {
                    const { DeviceId, SiteId, SiteName, TimeZoneID, Name, Abbreviation, OffsetMinutes } = item
                    return {
                        ...item,
                        DeviceId: DeviceId,
                        SiteId: SiteId,
                        SiteName: SiteName,
                        Abbreviation: Abbreviation,
                        OffsetMinutes: OffsetMinutes,
                        CameraName: Name,
                        TimezoneId: TimeZoneID,
                    }
                })
                dispatch(recordingActions.setDevicesList(temp));
            } else {
                const devicesList = response?.Data?.map(item => {
                    const { DeviceId, SiteId, SiteName, TimeZoneID, Name, Abbreviation, OffsetMinutes } = item;
                    return {
                        ...item,
                        DeviceId: DeviceId,
                        SiteId: SiteId,
                        SiteName: SiteName,
                        Abbreviation: Abbreviation,
                        OffsetMinutes: OffsetMinutes,
                        CameraName: Name,
                        TimezoneId: TimeZoneID,
                        isChecked: false
                    }
                })
                dispatch(recordingActions.setDevicesList(devicesList));                
            }
        }
        else{
            dispatch(recordingActions.setDevicesList([]))
            WarningToast("No devices configured for video backup")
        }
    }
    catch (ex) {
        console.log(ex);
    }
}

export const fetchCameraDetailsById = (deviceId) => async (dispatch) => {
    try {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };

        // let url = BASE_CORE_URL + "Cameras/GetCameraDetailsById" + `?deviceId=${deviceId}`;
        let url = UAPI_URL_CCTV + "getAllDevicesById" + `?deviceId=${deviceId}`;
        const response = await fetch(url, requestOptions).then(res => res.json());
        
        if (response?.Status === "success" && response?.Data) {
            let temp = response?.Data.map((item) => {
                const { alarmpanelHooterEnabledFlag, Communicationport, DeviceTypeID, SiteId, SiteName, TimeZoneID, Name, IsPtz, 
                    RTSPCameraUrl, cctvHooterEnabledFlag, isTwoWayEnabled, CamPassword, CameraPort, 
                    CamUser, ChannelNo, CameraIp, IsTranscodingEnabled, IsPlayBackTranscodingEnabled, 
                    InternetProtocolPort, CameraGuid, DeviceId, ClientName, CameraBrandId, Abbreviation,
                    BrandName, EntityType, SiteID, OffsetMinutes ,QCStartDate,QCEndDate,LiveDate,
                    onvifusername, onvifuserpassword, isonvif} = item
             
                return {
                    // ...item,                    
                    CCTVType: EntityType,
                    Abbreviation: Abbreviation,
                    BranchID: SiteID,
                    BrandName: BrandName,
                    CameraBrandId: CameraBrandId,
                    CameraName: Name,
                    CommunicationPort: Communicationport,
                    DeviceTypeID: 6,
                    IsPTZ: IsPtz,
                    Location: Location,
                    OffsetMinutes: OffsetMinutes,
                    ParentCameraID: DeviceId,
                    RTSPURL: RTSPCameraUrl,
                    ShowHooter: cctvHooterEnabledFlag || alarmpanelHooterEnabledFlag,
                    ShowTwoWay: isTwoWayEnabled,
                    SiteID: SiteId,
                    SiteName: SiteName,
                    StreamName: CameraGuid,
                    StreamingURL: "",
                    TimeZoneId: TimeZoneID,
                    camPassword: CamPassword,
                    camPort: CameraPort,
                    camUserName: CamUser,
                    channelNum: ChannelNo,
                    httpPort: InternetProtocolPort,
                    isChecked: false,
                    isPlaybackTranscoded: IsPlayBackTranscodingEnabled ? "1" : "0",
                    isTranscoded: IsTranscodingEnabled ? "1" : "0",
                    playbackURL: null,
                    privateIPAddress: CameraIp,
                    ClientName: ClientName,
                    QCStartDate:QCStartDate,
                    QCEndDate:QCEndDate,
                    LiveDate:LiveDate,
                    onvifusername: onvifusername,
                    onvifuserpassword: onvifuserpassword,
                    isonvif: isonvif
                }
            })
            dispatch(cameraActions.setCameraDetails(temp[0]));
        }
    }
    catch (ex) {
        console.log(ex);
    }
}

export const fetchRecordingCameraDetailsById = async (item) => {

    let { deviceId, startTime, endTime} = item
    console.log("starting line");
    try {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };

        // let url = BASE_CORE_URL + "Cameras/GetCameraDetailsById" + `?deviceId=${deviceId}`;
        let url = UAPI_URL_CCTV + "getAllRecordingDevicesById" + `?deviceId=${deviceId}&fromDateTime=${startTime}&toDateTime=${endTime}`;
        console.log("playback response", url);
        
        return await fetch(url, requestOptions).then(res => res.json())
        .then(function (data) {
            console.log("playback response", data);
            return data
        })
        .catch(function (error) {
            console.error(error);
        })
       
        // if (response?.Status === "success" && response?.Data) {
        //     console.log("response?.Data", response?.Data);
            
        //     let temp = response?.Data.map((item) => {
        //         console.log("response temp", temp);
                
        //         const { Data } = item
        //         return {
        //             VideoURL: Data
        //         }
        //     })
        //     // dispatch(recordingActions.setCameraDetails(temp[0]));
        // }
    }
    catch (ex) {
        console.log(ex);
    }
}

export const fetchRecordingStatusByDevicesId = async (item) => {

    let { deviceId, startDate, endDate} = item

    try {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };

        let url = UAPI_URL_CCTV + "getRecordingStatusByDevicesId" + `?deviceId=${deviceId}&fromDate=${startDate}&toDate=${endDate}`;
        console.log("playback response", url);
        
        return await fetch(url, requestOptions).then(res => res.json())
        .then(function (data) {
            console.log("playback response", data);
            return data
        })
        .catch(function (error) {
            console.error(error);
        })
       
    }
    catch (ex) {
        console.log(ex);
    }
}

// WD => Without dispatch
export const fetchCameraDetailsByIdWD = async (deviceId) => {
    try {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };

        // let url = BASE_CORE_URL + "Cameras/GetCameraDetailsById" + `?deviceId=${deviceId}`;
        let url = UAPI_URL_CCTV + "getAllDevicesById" + `?deviceId=${deviceId}`;
        const response = await fetch(url, requestOptions).then(res => res.json());

        if (response?.Status === "success" && response?.Data) {
            let temp = response?.Data.map((item) => {
                const { Communicationport, DeviceTypeID, SiteId, SiteName, TimeZoneID, Name, IsPtz, 
                    RTSPCameraUrl, cctvHooterEnabledFlag, isTwoWayEnabled, CamPassword, CameraPort, 
                    CamUser, ChannelNo, CameraIp, IsTranscodingEnabled, IsPlayBackTranscodingEnabled, 
                    InternetProtocolPort, CameraGuid, DeviceId, ClientName, CameraBrandId, Abbreviation,
                    BrandName, EntityType, SiteID, OffsetMinutes,InterfacePort,BranchID,Password,UserName,InterfaceIP } = item
                return {
                    // ...item,                    
                    CCTVType: EntityType,
                    Abbreviation: Abbreviation,
                    BranchID: SiteID,
                    BrandName: BrandName,
                    CameraBrandId: CameraBrandId,
                    CameraName: Name,
                    CommunicationPort: Communicationport,
                    DeviceTypeID: DeviceTypeID,
                    IsPTZ: IsPtz,
                    Location: Location,
                    OffsetMinutes: OffsetMinutes,
                    ParentCameraID: DeviceId,
                    RTSPURL: RTSPCameraUrl,
                    ShowHooter: cctvHooterEnabledFlag,
                    ShowTwoWay: isTwoWayEnabled,
                    SiteID: SiteId,
                    SiteName: SiteName,
                    StreamName: CameraGuid,
                    StreamingURL: "",
                    TimeZoneId: TimeZoneID,
                    camPassword: CamPassword,
                    camPort: CameraPort,
                    camUserName: CamUser,
                    channelNum: ChannelNo,
                    httpPort: InternetProtocolPort,
                    isChecked: false,
                    isPlaybackTranscoded: IsPlayBackTranscodingEnabled ? "1" : "0",
                    isTranscoded: IsTranscodingEnabled ? "1" : "0",
                    playbackURL: null,
                    privateIPAddress: CameraIp,
                    ClientName: ClientName,
                    InterfacePort:InterfacePort,
                    panelBranchID:BranchID,
                    Password:Password,
                    UserName:UserName,
                    InterfaceIP:InterfaceIP
                }
            })
            return temp[0];
        }
    }
    catch (ex) {
        console.log(ex);
    }
}




export const saveMosaicConfiguration = ({filterid,mosaicConfiguration,isdefault}) => async (dispatch) => {
    try {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };
        let loggedInUser = JSON.parse(localStorage.getItem('user'));
        let userUniqueId = loggedInUser?.Id;
        let mosaicConfigurationURL = mosaicConfiguration ? `&mosaicConfiguration=${mosaicConfiguration}` : ''
        
        let isdefaultURL = isdefault ? `&isdefault=${isdefault}` : ''
        // let url = BASE_CORE_URL + "Device/SaveFilter" + `?pName=${pName}&pType=${pType}&userUniqueId=${userUniqueId}&filterText=${filterText}`;
        let url = UAPI_URL_CONFIG + "mosaicConfiguration/SaveMosaicConfiguration" + `?filterid=${filterid}&userUniqueId=${userUniqueId}${mosaicConfigurationURL}${isdefaultURL}`;
        const response = await fetch(url, requestOptions).then(res => res.json());

        if (response?.Status === "success") {
            SuccessToast(response?.Message)
            // dispatch(fetchSavedFiltersList(pType))
        } else if (response?.Status === "failed") {
            ErrorToast(response?.Message)
        }
    }
    catch (ex) {
        console.log(ex);
    }
}

export const getMosaicConfiguration = async (filterid=null,isdefault=null) =>{
    try {
        const requestOptions = {
            method: "get",
            headers: {
                "Content-Type": "application/json",
                "authcode": localStorage.getItem('authCode'),
                "Authorization": "Bearer " + localStorage.getItem('authToken')
            },
        };
        let loggedInUser = JSON.parse(localStorage.getItem('user'));
        let userUniqueId = loggedInUser?.Id;
        // let url = BASE_CORE_URL + "Device/SaveFilter" + `?pName=${pName}&pType=${pType}&userUniqueId=${userUniqueId}&filterText=${filterText}`;
        let defaultURL = isdefault ? `&isdefault=${isdefault}` : ''
        let filteridURL = filterid ? `&filterid=${filterid}` : ''
        let url = UAPI_URL_CONFIG + "mosaicConfiguration/GetMosaicConfiguration" + `?userUniqueId=${userUniqueId}${filteridURL}${defaultURL}`;
        const response = await fetch(url, requestOptions).then(res => res.json());
        console.log("Step 2.1 executed",response)
        if (response?.Status === "success") {
            return response
        } else if (response?.Status === "failed") {
            ErrorToast(response?.Message)
        }
    }
    catch (ex) {
        console.log('myerror',ex);
    
}
}